export default __webpack_public_path__ + "static/media/a7031373-d517-4f0a-96d6-bf364b92adfa.7b6e2de8.JPG";